import { Component, OnInit } from '@angular/core';
import { EventsService } from '../../services/events-service/events.service';
import { ActivatedRoute } from '@angular/router';
import { DatewiseEvents } from '../../models/datewise-events';
import { ComponentBase } from '../../../../../base-classes/componet-base';
import { InterCopmonentDataCarrierService } from '../../../../../services/inter-copmonent-data-carrier-service/inter-copmonent-data-carrier.service';
import { DatePipe } from '@angular/common';
import { CalendarDataCarrierService } from '../../services/calendar-datacarrier-service/calendar-data-carrier.service';
import { WidgetType } from '../../models/calendar-view-cache';
import { PrifactRoute } from '../../../../../models/prifact-route';
import { RoutingService } from '../../../../../services/routing-service/routing.service';
import { DateUtils } from '../../../../../utils/date-utils';
import { MobileEventsService } from '../../services/mobile-events-servics/mobile-events.service';

@Component({
  selector: 'app-week',
  templateUrl: './week.component.html',
  styleUrls: ['./week.component.scss'],
  providers: [DatePipe]
})
export class WeekComponent extends ComponentBase implements OnInit {

  constructor(private eventsService: EventsService
    , private route: ActivatedRoute
    , private routingService: RoutingService
    , private interComponentService: InterCopmonentDataCarrierService
    , private datePipe: DatePipe
    , private calendarDataCarrierSvc: CalendarDataCarrierService
    , private mobileEventsService: MobileEventsService) {
    super();
  }

  startDate: Date = new Date();
  selectedWeek: Array<DatewiseEvents>;
  currentMonth: string;
  todaysdate = DateUtils.DateToISOString(new Date()).split('T')[0];

  ngOnInit() {
    let sub = this.route.params.subscribe(params => {
      let date = params['date'];
      if (date) {
        this.startDate = new Date(date);
      }
      else {
        this.startDate.setDate(this.startDate.getDate() - (this.startDate.getDay() != 0 ? this.startDate.getDay() - 1 : 6));
      }
      this.selectedWeek = [];
      let week_start_date = new Date(this.startDate);
      week_start_date.setDate(week_start_date.getDate() - (week_start_date.getDay() != 0 ? week_start_date.getDay() - 1 : 6));
      for (let i = 0; i < 7; i++) {
        let day = new DatewiseEvents();
        day.event_date = DateUtils.DateToISOString(week_start_date);
        this.selectedWeek.push(day);
        week_start_date.setDate(week_start_date.getDate() + 1);
      }
      this.mobileEventsService.getEventsForMonth(this.startDate);
    });
    this.addSubscription(sub);


    let sub1 = this.mobileEventsService.months$.subscribe(curr_month => {
      this.selectedWeek.forEach((day, j) => {
        let d = curr_month.event_days.find(o => o.event_date.split('T')[0] == day.event_date.split('T')[0]);
        if (d) {
          this.selectedWeek[j] = d;
        }
      });
      this.setCurrentMonth();
      this.calendarDataCarrierSvc.changeView(WidgetType.week, this.currentMonth, this.startDate);
    });
    this.addSubscription(sub1);
  }

  homeworkClicked(day: DatewiseEvents) {
    this.interComponentService.save("hwDate", day.event_date);
    let route = new PrifactRoute();
    route.url = '/pages/homeworks';
    route.append_current_url_to_history = true;
    this.routingService.navigate(route);
  }

  setCurrentMonth() {
    let weekStartMonth = this.datePipe.transform(this.selectedWeek[0].event_date, "MMMM y");
    let weekEndMonth = this.datePipe.transform(this.selectedWeek[this.selectedWeek.length - 1].event_date, "MMMM y");
    if (weekStartMonth == weekEndMonth) {
      this.currentMonth = weekStartMonth;
    }
    else {
      let year1 = this.datePipe.transform(this.selectedWeek[0].event_date, "y");
      let year2 = this.datePipe.transform(this.selectedWeek[this.selectedWeek.length - 1].event_date, "y")
      if (year1 != year2) {
        this.currentMonth = this.datePipe.transform(this.selectedWeek[0].event_date, "MMM y")
          + " - "
          + this.datePipe.transform(this.selectedWeek[this.selectedWeek.length - 1].event_date, "MMM y");
      }
      else {
        this.currentMonth = this.datePipe.transform(this.selectedWeek[0].event_date, "MMM")
          + " - "
          + this.datePipe.transform(this.selectedWeek[this.selectedWeek.length - 1].event_date, "MMM y");;
      }
    }
  }
}
